module.exports = __webpack_public_path__ + "img/poson.d6410664.png";